module.exports = __webpack_public_path__ + "static/img/pic8.42eee63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic8.png
// module id = /j68
// module chunks = 1